import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';
import DoubtData from '@models/DoubtsOnWeb2';

const useMyDoubts = (goalUID) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);

  const { data, isError, ...rest } = useFetch(
    isLoggedIn ? `v2/doubts/learner/mine/?goal_uid=${goalUID}` : null
  );

  const doubts =
    data?.results.map((doubt) => DoubtData.getEntityData(doubt)) || [];

  return {
    doubts,
    rest
  };
};

export default useMyDoubts;
